import React, { useEffect, useState } from 'react';
import axios from 'axios'; // Axios for API calls
import { useNavigate } from 'react-router-dom';
import '../index.css';

const REACT_APP_BASE_URL = process.env.REACT_APP_BASE_URL;

function LanguageSelection() {
  const [selectedLanguage, setSelectedLanguage] = useState(null);
  const [reloadKey, setReloadKey] = useState(0);
  const navigate = useNavigate();
  const authToken = localStorage.getItem("AuthToken");
  console.log(authToken, "authToken 15")

  useEffect(() => {
    const language = localStorage.getItem('selectedLanguage');
    if (language) {
      setSelectedLanguage(language);
    }
  }, []);


  const handleLanguageSelect = async (language) => {
    localStorage.setItem('selectedLanguage', language);
    setSelectedLanguage(language);
  
    try {
      const response = await axios.put(
        'https://api.japaking.online/api/users', 
        { language: language },
        { headers: { Authorization: `Bearer ${authToken}` } }
      );
  
      if (response?.data?.message) {
        // Save the token if needed
        localStorage.setItem('AuthToken', response?.data?.message?.token);
        console.log('Language Auth Token stored successfully:', response?.data?.message?.token);
      }
  
      // Navigate to Home Page after language selection
      window.location.href = '/';
  
    } catch (error) {
      console.log("Full error response:", error.response);
  
      if (error.response) {
        if (error.response.status === 400) {
          console.log('Invalid username/email or password');
        } else {
          const message = error.response?.data?.message || error.response?.data?.errors || 'An error occurred';
          console.log(typeof message === 'string' ? message : JSON.stringify(message));
        }
      } else {
        console.log('Network error. Please try again later.');
      }
     
      window.location.href = '/';
    }
  };
  
  

  return (
    <div
      className="language-container"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/new_language.png)`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        color: '#333',
        position: 'relative',
      }}
    >
      {/* Overlay to adjust image darkness */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.3)',
          zIndex: 1,
        }}
      ></div>

      {/* Content Box */}
      <div
        style={{
          zIndex: 2,
          width: '80%',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          alignItems: 'center',
        }}
      >
        <h1 className="language-title">JapaKing</h1>
        <div className="language-selection-box">
          <p className="language-subtitle">In which language do you want to use the app?</p>
          <div className="language-selection">
            <button
              className={`language-option ${selectedLanguage === 'enlish' ? 'selected' : ''}`}
              onClick={() => handleLanguageSelect('enlish')}
            >
              English Language
            </button>
            <button
              className={`language-option ${selectedLanguage === 'hindi' ? 'selected' : ''}`}
              onClick={() => handleLanguageSelect('hindi')}
            >
              हिंदी भाषा
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LanguageSelection;
